/**
 * Visit Notes Service Implementation (Core Layer)
 *
 * Business logic for visit notes management
 */

import type {
  IVisitNotesService,
  IVisitNotesRepository,
  ICreateVisitNoteRequest,
  IUpdateVisitNoteRequest,
  ICreateVisitNoteResponse,
  IUpdateVisitNoteResponse,
} from "../ports/driver/VisitNotesService";

export const VisitNotesServiceImplFactory = ({
  visitNotesRepository,
}: {
  visitNotesRepository: IVisitNotesRepository;
}): IVisitNotesService => {
  /**
   * Create a new visit note
   */
  const createVisitNote = async (
    request: ICreateVisitNoteRequest
  ): Promise<ICreateVisitNoteResponse> => {
    try {
      const data = await visitNotesRepository.createVisitNoteAPI(request);

      return {
        success: true,
        data,
      };
    } catch (error: any) {
      console.error(
        "[VisitNotesService] ❌ Failed to create visit note:",
        error
      );
      return {
        success: false,
        error: {
          message: error?.message || "Failed to create visit note",
          code: error?.code,
        },
      };
    }
  };

  /**
   * Update an existing visit note
   */
  const updateVisitNote = async (
    clinicId: number,
    patientId: number,
    noteId: number,
    request: IUpdateVisitNoteRequest
  ): Promise<IUpdateVisitNoteResponse> => {
    try {
      const data = await visitNotesRepository.updateVisitNoteAPI(
        clinicId,
        patientId,
        noteId,
        request
      );

      return {
        success: true,
        data,
      };
    } catch (error: any) {
      console.error(
        "[VisitNotesService] ❌ Failed to update visit note:",
        error
      );
      return {
        success: false,
        error: {
          message: error?.message || "Failed to update visit note",
          code: error?.code,
        },
      };
    }
  };

  return {
    createVisitNote,
    updateVisitNote,
  };
};
